import type { Item } from "#/types/items";

/**
 * Labels an item by what a user would actually recognise: its external ID,
 * falling back to the internal id, with the RFID tag appended when there is
 * one. Shared so every "pick an item" surface reads the same.
 */
export const describeItem = (item: Pick<Item, "id" | "external_id" | "rfid_tags">): string => {
  const name = item.external_id || `#${item.id}`;
  const rfid = item.rfid_tags?.[0]?.rfid;
  return rfid ? `${name} (${rfid})` : name;
};
